import MenuItem from "@mui/material/MenuItem";
import TextField from "../atoms/TextField";

const Select = ({ dataSource, mapKey, mapValue, ...props }: any) => {
  return (
    <TextField
      select
      {...props}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            sx: { maxHeight: 350 },
          },
        },
      }}
    >
      {dataSource ? (
        dataSource?.map((option: any) => (
          <MenuItem key={option[mapKey]} value={option[mapKey]}>
            {option[mapValue]}
          </MenuItem>
        ))
      ) : (
        <div></div>
      )}
    </TextField>
  );
};

export default Select;
